export default "__VITE_ASSET__BLZXu0Xg__"